import { FileAttachment, FileAttachmentV2 } from 'api/attachments';
import { Project } from 'api/project';
import { ProjectFileGroup } from 'api/project-files/types';
import { ArrElement } from 'utils/arrays';
import { CpWidgetProps } from '../../types/widget';
import { ListOrGridMode } from '../all-files/types';

export interface CpAccountFilesData extends Record<string, unknown> {
  title: string;
  description: string;
  folders: {
    project: Project;
    folders: ProjectFileGroup[];
    otherAttachments: { attachment: FileAttachment }[];
  }[];
}

export type ProjectFoldersInAccount = ArrElement<CpAccountFilesData['folders']>;

export interface CpAccountFilesWidgetProps extends CpWidgetProps {
  data: CpAccountFilesData;
}

export interface CpAccountFilesProps {
  search: string;
  currentFolder: ProjectFileGroup | undefined;
  onFolderClick: (
    args:
      | {
          projectId: number;
          folderId: number;
        }
      | undefined,
  ) => void;
  data: CpAccountFilesData;
  mode: ListOrGridMode;
  setMode: (mode: ListOrGridMode) => void;
  currentAttachments: (FileAttachment | FileAttachmentV2)[];
  handleDownload: (attachmentId: number) => void;
  onFileClick: (attachmentId: number) => void;
  projectId: number;
  refetch: () => void;
}

export const ator = (p: number) => `${p}_ator`;
